export default __webpack_public_path__ + "static/media/mbsp.9cae98e6.png";